import styled from "styled-components";
import { Flex } from "components";

export const Product = styled(Flex)`
  &:hover {
    background: #3c3c3c;
  }
`;
